import { EFiltersActions } from '@rfc/rfc-components-library/store'
import { ELocalStorage } from '@rfc/rfc-components-library/types'
import { setItemToStorage } from '@rfc/rfc-components-library/utils'
import type { Commit, Dispatch } from 'vuex'

const actions = {
    [EFiltersActions.SET_FILTER]: (
        { commit }: { commit: Commit; dispatch: Dispatch },
        filter: Record<string, string | number | boolean>
    ) => setItemToStorage(ELocalStorage.FILTERS, filter)
}

export default {
    namespaced: true,
    actions
}
